export default __webpack_public_path__ + "static/media/bugfiling.ee1e825b.png";